<template>
  <dl :class="classes">
    <dt class="dn-accordion__trigger" @click="toggle">
      <div class="dn-accordion__trigger-inner">
        <slot name="trigger" />
      </div>
      <div class="dn-accordion__trigger-icon-container">
        <dn-icon class="dn-accordion__trigger-icon" :icon="icon" />
      </div>
    </dt>
    <dd class="dn-accordion__body" ref="body">
      <slot name="body" />
    </dd>
  </dl>
</template>



<script>
import Toggleable from 'ui/mixins/toggleable';



const ACTIVATE_DURATION = 350;



export default {
  mixins: [Toggleable],



  data() {
    return {
      initialOpen: false,
    }
  },



  computed: {
    classes() {
      return {
        'dn-accordion': true,
        'dn-accordion--open': this.isActive || this.initialOpen,
      }
    },
    icon() { return this.isActive ? 'arrow-up-lg' : 'arrow-down-lg' },
  },



  watch: {
    isActive(isActive) {
      const $body = $(this.$refs.body);
      $body.stop();
      $body[isActive ? 'slideDown' : 'slideUp'](ACTIVATE_DURATION);
    },
  },

  methods: {
    toggle() {
      this.isActive = !this.isActive;
    },
  },

  created() {
    this.initialOpen = this.value;
  },
}
</script>


// WEBPACK FOOTER //
// Accordion.vue?e8358f20